import { createSelector } from 'reselect';

const withdrawalWizardSelector = (state) => state.order.withdrawalWizard;

export const selectWithdrawalWizardErrorMessage = createSelector(
  withdrawalWizardSelector,
  (state) => state.errorMessage,
);

export const selectVerifyCheckWithdrawal = createSelector(
  withdrawalWizardSelector,
  (state) => state.data,
);

export const selectVerifyWireWithdrawal = createSelector(
  withdrawalWizardSelector,
  (state) => state.verifyWireWithdrawal,
);
